export class NotDefinedInSchemaError extends Error {
  constructor(endpointName: string) {
    super(`Endpoint '${endpointName}' not defined in widget endpoints schema.`);
  }
}
